import React, { useState } from "react";
import mobileNotary from 'url:../../assets/mobileNotary.jpg';
import agent from 'url:../../assets/signingAgent1.jpg';
import apostille from 'url:../../assets/apostille.jpg';
import ron from 'url:../../assets/RON.jpg';
import { messages } from '../messages';
import Notary from './Notary'
import Apostille from "./Apostille";
import IconTitle from "./IconTitle";
import LoanSign from "./LoanSign";
import Remote from "./Remote";
import '../../index.css'
import './styles.css';

const Services = () => {
    const { services } = messages;
    const { remote } = messages;
    const [DisplayNotary, setDisplayNotary] = useState(false)
    const [DisplayLoanSign, setDisplayLoanSign] = useState(false)
    const [DisplayApostille, setDisplayApostille] = useState(false)
    const [DisplayRemoteNotary, setDisplayRemoteNotary] = useState(false)

    const toggleDisplayNotary = () => {
        setDisplayNotary(e => !e)
        setDisplayApostille(false)
        setDisplayLoanSign(false)
        setDisplayRemoteNotary(false)
    }

    const toggleDisplayLoanSign = () => {
        setDisplayLoanSign(e => !e)
        setDisplayApostille(false)
        setDisplayNotary(false)
        setDisplayRemoteNotary(false)
    }

    const toggleDisplayApostille = () => {
        setDisplayApostille(e => !e)
        setDisplayLoanSign(false)
        setDisplayNotary(false)
        setDisplayRemoteNotary(false)
    }

    const toggleDisplayRemoteNotary = () => {
        setDisplayRemoteNotary(e => !e)
        setDisplayLoanSign(false)
        setDisplayNotary(false)
        setDisplayApostille(false)
    }

    return (
        < >
            <div id="services" className="row">
            
                    <h2 style={{padding: '40px', textAlign:'left'}}  className="col s12 m12 l12 service-header">Services</h2>
                </div>
                  
                <div className="icons-obj ">
                    
                        <IconTitle title="Mobile Notary" onImageClick={toggleDisplayNotary} active={DisplayNotary} img={mobileNotary}/>
                        <IconTitle title="Apostille Agent" onImageClick={toggleDisplayApostille} active={DisplayApostille} img={apostille}/>
                        <IconTitle title="Certified Loan Signing Agent" onImageClick={toggleDisplayLoanSign} active={DisplayLoanSign} img={agent}/>
                        <IconTitle title="Remote Online Notary" onImageClick={toggleDisplayRemoteNotary} active={DisplayRemoteNotary} img={ron}/>
                    </div>
                    <div className="container">
                    {DisplayNotary && (<Notary data={services} />)}
                    {DisplayLoanSign && (<LoanSign data={services}/>)}
                    {DisplayApostille && (<Apostille app={services} />)}
                    {DisplayRemoteNotary && (<Remote app={remote} />)}
                    </div>
                   
            </>
        


    )
}

export default Services;